import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-observerappointments',
  templateUrl: './observerappointments.component.html',
  styleUrls: ['./observerappointments.component.scss']
})
export class ObserverappointmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
